module.exports = __webpack_public_path__ + "media/sustainability.d88d4153.mp4";